export default __webpack_public_path__ + "static/media/land_type_desert.7b3492fb.jpg";